// Release builds keep console output (Android logcat, Sentry console breadcrumbs), so a URL must never be
// logged as-is when it can carry credentials: Supabase OAuth callbacks put access_token / refresh_token in
// the hash and the PKCE code in the query, and quiz share links carry a quiz access token.
const SENSITIVE_PARAM =
  /([?#&](?:access_token|refresh_token|provider_token|provider_refresh_token|id_token|token|token_hash|code)=)[^&#]*/gi;

/** The URL with every credential-bearing query or hash parameter value replaced, safe to log. */
export function redactUrl(url: string): string {
  return url.replace(SENSITIVE_PARAM, '$1[redacted]');
}
